module.exports = __webpack_public_path__ + "img/promotion.c1eabb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/promotion.png
// module id = 5knE
// module chunks = 39 44